import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { connect } from 'react-redux';
import classNames from 'classnames';
import s from './EditonSwitch.scss';

class EditonSwitch extends React.Component {
  renderEditionItems = (items, flag = true) => {
    const defaultCountry = items.editions.filter(
      item => item.default === true,
    )[0];
    return (
      <div
        className={`${s['text-display']} ${s[`${defaultCountry?.id}`]} ${
          !flag ? s.noFlag : ''
        }`}
      >
        <span>{defaultCountry?.label}</span>
        <ul>
          {items &&
            items.editions &&
            Array.isArray(items.editions) &&
            items.editions.length > 0 &&
            items.editions.map(item => (
              <li
                className={classNames({
                  [`${s.us}`]: item?.id === `us`,
                  [`${s.india}`]: item?.id === `in`,
                })}
                key={item?.id}
              >
                <Link
                  to={item.link}
                  target={item.openInNewTab ? '_blank' : ''}
                  data-newga={`switch_country#switch_country_${item?.id}`}
                  aria-label={item.label}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: 'header',
                      category: `switch_country_${item?.id}`,
                    },
                  ]}
                >
                  {item.label}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    );
  };

  render() {
    const {
      colorTheme,
      doNotshowEditionText,
      label = 'Edition',
      editionSwitch,
      editionSwitchLanguage,
    } = this.props;
    const theme = this.props.colorTheme ? s[colorTheme] : '';
    return (
      <div
        className={`${s[`${this.props?.editionSwitch?.theme}`] || ''}
         ${theme}
         ${s['edition-box']}`}
      >
        <>
          {!doNotshowEditionText && <span className={s.text}>{label}</span>}
          {editionSwitch?.editions &&
            Array.isArray(editionSwitch.editions) &&
            editionSwitch.editions.length > 0 &&
            this.renderEditionItems(editionSwitch)}
          {editionSwitchLanguage?.editions &&
            Array.isArray(editionSwitchLanguage.editions) &&
            editionSwitchLanguage.editions.length > 0 &&
            this.renderEditionItems(editionSwitchLanguage, false)}
        </>
        {/* {showTOIPlus && */}
        {!this.props.isReviewsPage &&
          this.props.showToiPlusEntryPoints && (
            <div className={s.toiplus}>
              <Link to="/toi-plus">
                <i />
              </Link>
            </div>
          )}
      </div>
    );
  }
}

EditonSwitch.propTypes = {
  editionSwitch: PropTypes.shape({
    editions: PropTypes.instanceOf(Array),
    theme: PropTypes.string,
  }).isRequired,
  colorTheme: PropTypes.string,
  // showTOIPlus: PropTypes.bool,
  // isPrimeUser: PropTypes.bool,
  showToiPlusEntryPoints: PropTypes.bool,
  doNotshowEditionText: PropTypes.bool,
  isReviewsPage: PropTypes.bool,
};
EditonSwitch.defaultProps = {
  colorTheme: '',
  // showTOIPlus: false,
  // isPrimeUser: true,
  showToiPlusEntryPoints: false,
  doNotshowEditionText: false,
  isReviewsPage: false,
};
const mapStateToProps = state => ({
  isReviewsPage: state.isTOIReviews,
});
export default connect(mapStateToProps)(EditonSwitch);
